export default "__VITE_ASSET__DNtoyzUy__"